/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duplicate_By_DayInputs */



/**
* | output |
* | --- |
* | "Duplicate a day to other days" |
*
* @param {Duplicate_By_DayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duplicate_by_day = /** @type {((inputs?: Duplicate_By_DayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_By_DayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Duplicate a day to other days")
	return /** @type {LocalizedString} */ ("Dupliquer un jour vers d'autres jours")
});